
    const data = {"name":"src/core/icons/plus","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            